// Is possible to use https://github.com/pillarjs/path-to-regexp for compile routes
const availableRoutes = {
  login: '/login',
  newUser: '/',
  signUp: '/sign-up',
  signUpSuccess: '/sign-up-success',
  joinOrganization: '/join-organization/:token',
  dashboard: '/dashboard',
  clients: '/clients',
  clientDetails: '/clients/:id',
  proposalAndContracts: '/proposals-and-contracts',
  proposalAndContractsTemplates: '/proposals-and-contracts/templates-library',
  proposalAndContractTemplateNew: '/proposals-and-contracts/templates-library/custom/new',
  proposalAndContractTemplateEdit: '/proposals-and-contracts/templates-library/:id',
  proposalAndContractTemplatePreview: '/proposals-and-contracts/templates-library/previews/:id',
  proposalAndContractCustomTemplatePreview: '/proposals-and-contracts/templates-library/custom/previews/:id',
  proposalAndContractEdit: '/proposals-and-contracts/:id',
  proposalAndContractPreview: '/proposal-and-contract/preview/:id',
  proposalAndContractView: '/proposal-and-contract/view/:token',
  tasks: '/tasks',
  tasksDetails: '/tasks/:id',
  finances: '/finances',
  invoices: '/finances/invoice',
  invoicesDetails: '/finances/invoice/:id',
  invoicesPreview: '/finances/invoice/preview/:id',
  invoiceView: '/finances/invoice/view/:token',
  timetracking: '/timetracking',
  billingAndSuscription: '/billing-and-subscription',
  settings: '/settings',
  error: {
    404: '/404',
    media: '/media-error',
  },
  stripeConnect: '/stripe/connect',
  requestResetPassword: '/request-reset-password',
  resetPassword: '/reset-password',
};

export {
  availableRoutes,
};
